export default {
  api: 'http://kidiforniadreambig-api.resn.info/api/wxshare',

  generic: {
    title: '奇了个怪，不一样的加州之旅！',
    desc: '奇了个怪，不一样的加州之旅！',
    moments: '奇了个怪，不一样的加州之旅！',
  },
}
